import { render, staticRenderFns } from "./schedule-item.vue?vue&type=template&id=875ba1ca&scoped=true"
import script from "./schedule-item.vue?vue&type=script&lang=js"
export * from "./schedule-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "875ba1ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('875ba1ca')) {
      api.createRecord('875ba1ca', component.options)
    } else {
      api.reload('875ba1ca', component.options)
    }
    module.hot.accept("./schedule-item.vue?vue&type=template&id=875ba1ca&scoped=true", function () {
      api.rerender('875ba1ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/chat/schedule-message/schedule-item.vue"
export default component.exports